var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkflowDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16.016,
    viewBox: "0 0 16.016 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5849",
    "data-name": "Group 5849",
    transform: "translate(-8370 -19659)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5849-2",
    "data-name": "Group 5849",
    transform: "translate(8370 19659)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "noun-workflow-3499262",
    d: "M118.476,46.434a2.285,2.285,0,0,0-2.206,1.715h-6.941a2.287,2.287,0,0,1,0-4.574h1.225a2.276,2.276,0,0,0,4.411,0h1.225a3.43,3.43,0,1,0,0-6.86h-6.941a2.287,2.287,0,1,0,0,1.143h6.941a2.287,2.287,0,0,1,0,4.574h-1.225a2.276,2.276,0,0,0-4.411,0h-1.225a3.43,3.43,0,1,0,0,6.86h6.941a2.283,2.283,0,1,0,2.206-2.859Zm-11.434-8a1.145,1.145,0,1,1,.808-.335A1.144,1.144,0,0,1,107.042,38.431Zm5.717,3.43a1.145,1.145,0,1,1-.808.335A1.144,1.144,0,0,1,112.759,41.861Zm5.717,8a1.145,1.145,0,1,1,.808-.335A1.144,1.144,0,0,1,118.476,49.865Z",
    transform: "translate(-104.747 -35)",
    fill: "#333333"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkflowDark);
export default __webpack_public_path__ + "static/media/workflow-dark.56d33de9917eb871628f0c77f5f871a3.svg";
export { ForwardRef as ReactComponent };